var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('DesktopDashboard',{attrs:{"measurements":_vm.measurements}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }